import { render } from "./NotificationPopup.vue?vue&type=template&id=230f46ca&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"

import "./NotificationPopup.vue?vue&type=style&index=0&id=230f46ca&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230f46ca"]])

export default __exports__